import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/lib/auth';
import { toast } from 'sonner';

export default function AdminLogin() {
    const { loginAdmin } = useAuth();
    const navigate = useNavigate();
    const [email, setEmail] = useState('admin@inorbit.one');
    const [password, setPassword] = useState('Inorbit@2026');
    const [busy, setBusy] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        setBusy(true);
        try {
            await loginAdmin(email, password);
            navigate('/admin');
        } catch (err) {
            toast.error(err?.response?.data?.detail || 'Invalid credentials');
        } finally { setBusy(false); }
    };

    return (
        <div className="min-h-screen bg-navy flex items-center justify-center px-6" data-testid="admin-login-page">
            <form onSubmit={submit} className="w-full max-w-md bg-white p-12">
                <div className="text-center mb-12">
                    <div className="font-serif text-3xl text-navy">INORBIT</div>
                    <div className="text-[10px] tracking-[0.3em] text-gold font-semibold mt-1">ONE • ADMIN</div>
                </div>
                <div className="space-y-6">
                    <div>
                        <label className="overline">Email</label>
                        <input type="email" className="input-luxury" value={email} onChange={(e) => setEmail(e.target.value)} required data-testid="admin-email-input" />
                    </div>
                    <div>
                        <label className="overline">Password</label>
                        <input type="password" className="input-luxury" value={password} onChange={(e) => setPassword(e.target.value)} required data-testid="admin-password-input" />
                    </div>
                </div>
                <button type="submit" disabled={busy} className="btn-primary mt-10 w-full justify-center" data-testid="admin-login-btn">
                    {busy ? 'Signing in…' : 'Access Admin Console'}
                </button>
                <div className="text-xs text-text-tertiary text-center mt-8 leading-relaxed">
                    Super Admin: admin@inorbit.one<br />Password: Inorbit@2026
                </div>
            </form>
        </div>
    );
}
